import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { LegalModal } from './ui/LegalModal';
export function ClosingSection() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="bg-[#060E1A] text-white py-10 md:py-16 px-4 md:px-6" data-id="element-63">
        <div className="max-w-3xl mx-auto" data-id="element-64">
          <FadeIn data-id="element-65">
            <div className="mb-8 md:mb-12" data-id="element-66">
              <span className="inline-block bg-gold text-navy font-serif font-bold px-3 py-0.5 md:px-4 md:py-1 rounded-full mb-4 md:mb-6 text-sm" data-id="element-67">
                P.D.
              </span>

              <div className="space-y-4 md:space-y-6 text-base md:text-xl text-white/80 font-serif italic leading-relaxed" data-id="element-68">
                <p data-id="element-69">
                  No necesitas hacerlo perfecto. <br data-id="element-70" />
                  <span className="text-gold font-bold" data-id="element-71">
                    Necesitas hacerlo en orden.
                  </span>
                </p>

                <p data-id="element-72">
                  Cuando tú duermes, todo mejora: tu paciencia, tu energía, tu
                  salud mental y tu maternidad.
                </p>

                <p data-id="element-73">
                  Esta guía (y el planificador) son para ayudarte a volver a ti…
                  mientras tu bebé aprende a dormir mejor.
                </p>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-74">
            <div className="pt-6 md:pt-8 border-t border-white/10 text-center" data-id="element-75">
              <p className="font-serif text-gold tracking-widest uppercase text-xs md:text-sm" data-id="element-76">
                Maternidad en Equilibrio
              </p>
              <p className="text-white/30 text-xs md:text-sm mt-3 md:mt-4 font-sans" data-id="element-77">
                © {new Date().getFullYear()} Todos los derechos reservados.
              </p>

              <div className="flex items-center justify-center gap-3 md:gap-4 mt-3 md:mt-4" data-id="element-78">
                <button onClick={() => setActiveModal('privacy')} className="text-white/30 hover:text-gold text-xs md:text-sm font-sans transition-colors duration-200 underline underline-offset-2" data-id="element-79">
                  Política de Privacidad
                </button>
                <span className="text-white/15" data-id="element-80">·</span>
                <button onClick={() => setActiveModal('terms')} className="text-white/30 hover:text-gold text-xs md:text-sm font-sans transition-colors duration-200 underline underline-offset-2" data-id="element-81">
                  Términos y Condiciones
                </button>
              </div>
            </div>
          </FadeIn>
        </div>
      </footer>

      <LegalModal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de Privacidad" data-id="element-82">
        <p className="font-semibold text-white" data-id="element-83">
          Última actualización:{' '}
          {new Date().toLocaleDateString('es-ES', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>
        <p data-id="element-84">
          En <strong data-id="element-85">Maternidad en Equilibrio</strong>, respetamos tu privacidad
          y nos comprometemos a proteger tus datos personales. Esta política
          describe cómo recopilamos, usamos y protegemos tu información.
        </p>
        <h3 data-id="element-86">1. Información que recopilamos</h3>
        <p data-id="element-87">
          Recopilamos únicamente la información necesaria para procesar tu
          compra:
        </p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-88">
          <li data-id="element-89">Nombre y dirección de correo electrónico</li>
          <li data-id="element-90">Información de pago (procesada de forma segura por terceros)</li>
        </ul>
        <h3 data-id="element-91">2. Uso de la información</h3>
        <p data-id="element-92">Utilizamos tu información para:</p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-93">
          <li data-id="element-94">Entregar el producto digital adquirido</li>
          <li data-id="element-95">Enviar confirmación de compra y actualizaciones relevantes</li>
          <li data-id="element-96">Mejorar nuestros productos y servicios</li>
        </ul>
        <h3 data-id="element-97">3. Protección de datos</h3>
        <p data-id="element-98">
          Implementamos medidas de seguridad técnicas y organizativas para
          proteger tus datos personales contra acceso no autorizado, pérdida o
          alteración.
        </p>
        <h3 data-id="element-99">4. Compartir información</h3>
        <p data-id="element-100">
          No vendemos, alquilamos ni compartimos tu información personal con
          terceros, excepto cuando sea necesario para procesar tu compra o
          cuando lo exija la ley.
        </p>
        <h3 data-id="element-101">5. Tus derechos</h3>
        <p data-id="element-102">
          Tienes derecho a acceder, rectificar o eliminar tus datos personales
          en cualquier momento. También puedes solicitar la limitación del
          tratamiento de tus datos.
        </p>
        <h3 data-id="element-103">6. Cookies</h3>
        <p data-id="element-104">
          Este sitio puede utilizar cookies para mejorar tu experiencia de
          navegación. Puedes configurar tu navegador para rechazar cookies si lo
          prefieres.
        </p>
      </LegalModal>

      <LegalModal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos y Condiciones" data-id="element-105">
        <p className="font-semibold text-white" data-id="element-106">
          Última actualización:{' '}
          {new Date().toLocaleDateString('es-ES', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>
        <p data-id="element-107">
          Al adquirir la <strong data-id="element-108">"Guía del Sueño del Bebé (0 a 3 Años)"</strong>{' '}
          y el <strong data-id="element-109">Planificador de Sueño del Bebé</strong>, aceptas los
          siguientes términos y condiciones.
        </p>
        <h3 data-id="element-110">1. Producto digital</h3>
        <p data-id="element-111">
          Este es un producto digital (ebook + planificador) que se entrega en
          formato electrónico. Una vez realizada la compra, recibirás acceso
          inmediato al contenido.
        </p>
        <h3 data-id="element-112">2. Uso personal</h3>
        <p data-id="element-113">
          El contenido adquirido es para uso personal y privado. Queda prohibida
          la reproducción, distribución, reventa o compartición del material sin
          autorización expresa.
        </p>
        <h3 data-id="element-114">3. Propiedad intelectual</h3>
        <p data-id="element-115">
          Todo el contenido, incluyendo textos, diseños e ilustraciones, es
          propiedad de Maternidad en Equilibrio y está protegido por las leyes
          de propiedad intelectual.
        </p>
        <h3 data-id="element-116">4. Descargo de responsabilidad</h3>
        <p data-id="element-117">
          La información proporcionada en esta guía es de carácter educativo e
          informativo. No sustituye el consejo médico profesional. Consulta
          siempre con tu pediatra ante cualquier duda sobre la salud de tu bebé.
        </p>
        <h3 data-id="element-118">5. Política de reembolso</h3>
        <p data-id="element-119">
          Debido a la naturaleza digital del producto, no se aceptan
          devoluciones una vez entregado el acceso al contenido, salvo en casos
          excepcionales evaluados individualmente.
        </p>
        <h3 data-id="element-120">6. Modificaciones</h3>
        <p data-id="element-121">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Las modificaciones serán efectivas desde su publicación en
          esta página.
        </p>
      </LegalModal>
    </>;
}